export const setsAvailableDatesField = {
    read(_, { readField }) {
        // const trialDatesArr = readField('eeAvailableDates');
        const everydayDatesArr = readField('everydayAvailableDates');
        const premiumDatasArr = readField('premiumAvailableDates');

        const allAvailableDates = [...new Set([
            ...everydayDatesArr, ...premiumDatasArr,
        ])].sort();

        return allAvailableDates;
    },
};


